(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/shared/components/slide-indicator.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/shared/components/slide-indicator.js');
"use strict";


const {
  useMemo
} = React;
const {
  NavigationIndicator,
  NavigationIndicatorDot,
  NavigationIndicatorPrev,
  NavigationIndicatorNext
} = svs.ui.ReactNavigationIndicator;
const SlideIndicator = _ref => {
  let {
    totalCount,
    activeSlide,
    setActiveSlide,
    isNextDisabled,
    nextSlide,
    isPrevDisabled,
    prevSlide,
    className = ''
  } = _ref;
  const dotsArr = useMemo(() => Array.from({
    length: totalCount
  }, (_, index) => React.createElement(NavigationIndicatorDot, {
    "aria-current": activeSlide === index ? 'true' : undefined,
    "aria-label": "Sida ".concat(index + 1, " av ").concat(totalCount),
    className: "navigation-indicator-dot ".concat(activeSlide === index ? 'navigation-indicator-dotactive' : ''),
    isActive: activeSlide === index,
    key: index,
    onClick: () => setActiveSlide(index)
  })), [totalCount, activeSlide, setActiveSlide]);
  return React.createElement(NavigationIndicator, {
    className: className
  }, React.createElement(NavigationIndicatorPrev, {
    "aria-label": "F\xF6reg\xE5ende sida",
    disabled: isPrevDisabled,
    onClick: prevSlide
  }), dotsArr, React.createElement(NavigationIndicatorNext, {
    "aria-label": "N\xE4sta sida",
    disabled: isNextDisabled,
    onClick: nextSlide
  }));
};
setGlobal('svs.eInstant.shared.components.SlideIndicator', SlideIndicator);

 })(window);